module.exports = __webpack_public_path__ + "assets/img/2.7ba9359f.jpg";